import useWallet from "./Wallet/useWallet";
import moment from "moment";
import { withdraw, shoesHandle, userBind } from "../api";
import { handlerWalletTxError } from "../utils/utils";
import { useIntl } from "react-intl";
import { Toast } from "antd-mobile";
import useGlobal from "./useGlobal";

import { Modal } from "antd-mobile";
const DEFAULT_SIGN = "0x0000000000000000000000000000000000000000";
export default function usePersonSign() {
  const intl = useIntl();
  const { myAccount } = useWallet();
  const { userInfo, loadUserInfo, loadUserShoesInfo } = useGlobal();
  const getMessage = (id) =>  intl.formatMessage({ id });

  const showConfrim = (Content) => {
    return new Promise((reslove, reject) => {
      const m = Modal.show({
        title: intl.formatMessage({
          id: "pages.account.profit_harvest_title",
          defaultMessage: "通知",
        }),
        bodyClassName: "runbit_modal",
        showCloseButton: true,
        actions: [
          {
            key: "prev",
            className: "border_btn",
            text: intl.formatMessage({
              id: "common.cancel",
              defaultMessage: "取消",
            }),
          },
          {
            key: "confrim",
            className: "primary_btn",
            text: intl.formatMessage({
              id: "common.confrim",
              defaultMessage: "確定",
            }),
            primary: true,
          },
        ],
        onAction: async (action, index) => {
          m.close();
          if (action.key === "confrim") {
            reslove();
            return;
          }
          reject();
        },
        closeOnAction: false,
        content: Content,
      });
    });
  };
  const sendWithdraw = async (amount) => {
    try {
      Toast.show({
        icon: "loading",
        duration: 0,
        content: getMessage("提币中..."),
        maskClickable: false,
      });
      const msg = `Operation: withdraw\nAmount: ${amount}RT\nTime: ${moment().format(
        "YYYY/MM/DD HH:mm:ss"
      )}`;
      let sign = DEFAULT_SIGN;
      if (!myAccount.isContract) {
        sign = await window.ethereum.request({
          method: "personal_sign",
          params: [msg, myAccount.account],
        });
      }

      await withdraw({
        address: myAccount.account,
        msg,
        sign,
      });
      Toast.show({
        content: getMessage("提币成功！"),
        icon: "success",
      });
    } catch (e) {
      const reason = handlerWalletTxError(e, intl);
      Toast.show({
        content: getMessage("提币失败") + ": " + reason,
        icon: "fail",
      });
      return "";
    }
  };
  const sendShoesHandle = async (type, data) => {
    let msg;
    let text_id;
    let fail_id;
    let success_id;
    if (type === "binding") {
      success_id = "components.equip_modal.mount_success";
      fail_id = "components.equip_modal.mount_fail";
      text_id = "components.equip_modal.mount_preparing";
      msg = `Operation: binding\nSlot: ${data.slot}\nTokenId: ${
        data.id
      }\nTime: ${moment().format("YYYY/MM/DD HH:mm:ss")}`;
    }
    if (type === "unbinding") {
      success_id = "components.equip_modal.unmount_success";
      text_id = "components.equip_modal.unmount_preparing";
      fail_id = "components.equip_modal.unmount_fail";
      msg = `Operation: unbinding\nSlot: ${data.slot}\nTokenId: ${
        data.id
      }\nTime: ${moment().format("YYYY/MM/DD HH:mm:ss")}`;
    }
    try {
      let sign = DEFAULT_SIGN;
     
      if (!myAccount.isContract) {
        Toast.show({
          icon: "loading",
          duration: 0,
          content: intl.formatMessage({
            id: text_id,
            defaultMessage: "裝備卸下中...",
          }),
          maskClickable: false,
        });
        sign = await window.ethereum.request({
          method: "personal_sign",
          params: [msg, myAccount.account],
        });
      } else {
        await showConfrim(
          <div>是否继续{type === "unbinding" ? "卸载" : "绑定"}该装备？</div>
        );
      }
      await shoesHandle({
        address: myAccount.account,
        msg,
        sign,
      });

      const equip = userInfo.equips.find((e) => e.id === data.id);

      if (type === "binding") {
        equip.is_bind = true;
        equip.slot = data.slot;

        userInfo.bind_num = userInfo.bind_num + 1;
      }
      if (type === "unbinding") {
        equip.is_bind = false;
        equip.slot = -1;
        userInfo.bind_num = userInfo.bind_num - 1;
      }
      Toast.show({
        content: intl.formatMessage({
          id: success_id,
        }),
        icon: "success",
      });
      loadUserShoesInfo(JSON.parse(JSON.stringify(userInfo)));
      setTimeout(() => {
        loadUserInfo();
      }, 1000);
    } catch (e) {
      const reason = handlerWalletTxError(e, intl);
      Toast.show({
        content:
          intl.formatMessage({
            id: fail_id,
          }) +
          ": " +
          reason,
        icon: "fail",
      });
    }
  };

  const sendUserBind = async (referrer) => {
    let sign = DEFAULT_SIGN;
    const msg = `Operation: initialization\nReferrer: ${referrer}\nTime: ${moment().format(
      "YYYY/MM/DD HH:mm:ss"
    )}`;
    if (!myAccount.isContract) {
      sign = await window.ethereum.request({
        method: "personal_sign",
        params: [msg, myAccount.account],
      });
    }
    await userBind({
      address: myAccount.account,
      msg,
      sign,
    });
  };

  return {
    sendWithdraw,
    sendShoesHandle,
    sendUserBind,
  };
}
